import { render, staticRenderFns } from "./resetMyKey.vue?vue&type=template&id=0ccc8c5a&scoped=true"
import script from "./resetMyKey.vue?vue&type=script&lang=js"
export * from "./resetMyKey.vue?vue&type=script&lang=js"
import style0 from "./resetMyKey.vue?vue&type=style&index=0&id=0ccc8c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc8c5a",
  null
  
)

export default component.exports